import { ColorSchemeProvider, MantineProvider } from "@mantine/core";
import { DatesProvider } from "@mantine/dates";
import { useLocalStorage } from "@mantine/hooks";
import { ModalsProvider } from "@mantine/modals";
import axios from "axios";
import dayjs from "dayjs";
import { RouterProvider, ScrollRestoration } from "react-router-dom";
import { API } from "./config";
import SplashScreen from "./pages/common/Splash";
import routes from "./routes";
import useAuthStore from "./store/useAuthStore";
import { createTheme } from "./theme";
import "dayjs/locale/ko";
import relativeTime from "dayjs/plugin/relativeTime";
import dayjsBusinessDays from "dayjs-business-days";
import "yet-another-react-lightbox/styles.css";
import { NuqsAdapter } from "nuqs/adapters/react-router/v6";
import { useEffect } from "react";
import { Toaster } from "sonner";
import AppUpdateModal from "./components/AppUpdateModal";

dayjs.extend(dayjsBusinessDays);
dayjs.extend(relativeTime);

dayjs.locale("ko");

axios.defaults.baseURL = API;

function App() {
  const [colorScheme, setColorScheme] = useLocalStorage({
    key: "color-scheme",
    defaultValue: "light",
    getInitialValueInEffect: true,
  });

  const toggleColorScheme = (value) =>
    setColorScheme(value || (colorScheme === "dark" ? "light" : "dark"));
  const theme = createTheme(colorScheme);

  const init = useAuthStore((state) => state.init);
  const handleAuthInit = useAuthStore((state) => state.handleAuthInit);
  const handleLogout = useAuthStore((state) => state.handleLogout);

  // biome-ignore lint/correctness/useExhaustiveDependencies: it's not necessary
  useEffect(() => {
    // console.log("start!");
    const jwt = localStorage.getItem("jwt");
    if (jwt) handleAuthInit(jwt);
    if (!jwt) handleLogout();
  }, []);

  return (
    <ColorSchemeProvider colorScheme={colorScheme} toggleColorScheme={toggleColorScheme}>
      <MantineProvider withGlobalStyles withNormalizeCSS theme={theme}>
        <DatesProvider settings={{ locale: "ko" }}>
          <ModalsProvider labels={{ confirm: "확인", cancel: "취소" }}>
            {init ? (
              <NuqsAdapter>
                <RouterProvider router={routes}>
                  <ScrollRestoration />
                </RouterProvider>
              </NuqsAdapter>
            ) : (
              <SplashScreen />
            )}
            <Toaster position="top-center" />
            <AppUpdateModal />
          </ModalsProvider>
        </DatesProvider>
      </MantineProvider>
    </ColorSchemeProvider>
  );
}

export default App;
